module.exports = __webpack_public_path__ + "img/92.f26972f2.jpg";